import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon } from 'lucide-react';
import { tomes } from '../data/content';
export function Tomes() {
  return <section className="w-full bg-white py-16 sm:py-24" aria-labelledby="tomes-title" data-id="element-212" data-mp="1ytbj6yjd9vzk">
      <div className="mx-auto max-w-6xl px-6" data-id="element-213" data-mp="1ty5zm6dfsten">
        <h2 id="tomes-title" className="mx-auto max-w-3xl text-center text-3xl font-extrabold leading-tight tracking-tight text-navy-deep sm:text-4xl" data-id="element-214" data-mp="1p1p9j6mog4yx">
          Six Guides. Six Layers of Protection. One System That Covers Every Risk In Your Home.
        </h2>

        <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-215" data-mp="1b0v0qmvpw1zq">
          {tomes.map((tome, index) => <motion.article key={tome.number} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.45,
          delay: index % 3 * 0.08,
          ease: 'easeOut'
        }} className="flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-7 shadow-sm transition-shadow duration-200 hover:shadow-lg" data-id="element-216" data-mp="163379offc7tf" data-mpi={index}>
              <div className="flex items-start gap-4" data-id="element-217" data-mp="1xir50wyb9aof">
                {tome.image ? <img src={tome.image} alt={`Tome ${tome.number} — ${tome.title} cover`} className="h-28 w-20 shrink-0 rounded-lg border border-slate-200 object-contain shadow-sm" loading="lazy" data-id="element-218" data-mp="1xl3vjyi4wtd3" /> : <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-navy/10 text-navy" data-id="element-219" data-mp="2ghv87p368a86">
                    <BookOpenIcon className="h-5 w-5" aria-hidden="true" data-id="element-220" data-mp="2lfwvkm7mqvpg" />
                  </span>}

                <div className="min-w-0 flex-1" data-id="element-221" data-mp="395hex67p3uz9">
                  <div className="flex items-baseline justify-between gap-3" data-id="element-222" data-mp="3dwzebpu2lni4">
                    <p className="text-xs font-bold uppercase tracking-[0.16em] text-trust-dark" data-id="element-223" data-mp="3dz2eh2oxsx0k">
                      Tome {tome.number}
                    </p>
                    <span className="text-2xl font-extrabold tracking-tight text-slate-200" data-id="element-224" data-mp="3iv6fri7fg7ok">
                      {tome.number}
                    </span>
                  </div>
                  <h3 className="mt-2 text-lg font-bold leading-snug text-navy-deep" data-id="element-225" data-mp="39tzvqz5kkeqk">
                    {tome.title}
                  </h3>
                </div>
              </div>

              <p className="mt-4 text-sm font-semibold leading-snug text-navy" data-id="element-226" data-mp="303ncda9hqrm0">{tome.subtitle}</p>
              <p className="mt-3 leading-relaxed text-ink/75" data-id="element-227" data-mp="2v40zj1xkrddq">{tome.body}</p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}